export const flowAcademicReportZH = {
  flowAcademicReport1: '下载',
  flowAcademicReport2: '暂无学术报告',
  flowAcademicReport3: '您已选择，无法更改',
  flowAcademicReport4: '雷达图1：',
  flowAcademicReport5: '显示',
  flowAcademicReport6: '不显示',
  flowAcademicReport7: '隐藏',
  flowAcademicReport9: '雷达图设置'
}

export const flowAcademicReportEN = {
  flowAcademicReport1: 'Download',
  flowAcademicReport2: 'No academic reports',
  flowAcademicReport3: `You've selected and can't change`,
  flowAcademicReport4: 'Radar Figure 1:',
  flowAcademicReport5: 'Unfold',
  flowAcademicReport6: `Fold`,
  flowAcademicReport7: 'Hide',
  flowAcademicReport9: 'Radar Chart Settings'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/academicReport.js